import styled from 'styled-components';
import { motion, useInView } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionProjectStoreProps extends PropsWithChildren {
  className?: string;
  href?: string;
  target?: string;
}

export const MotionProjectStore = ({
  children,
  className,
  href,
  target = '_blank',
}: MotionProjectStoreProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: ANIMATION_CONFIG.store.amount,
  });

  return (
    <MotionProjectStoreWrapper
      ref={ref}
      className={className}
      href={href}
      target={target}
      initial={{ opacity: 0, scale: ANIMATION_CONFIG.store.scale }}
      animate={
        isInView
          ? { opacity: 1, scale: 1 }
          : { opacity: 0, scale: ANIMATION_CONFIG.store.scale }
      }
      transition={{
        duration: ANIMATION_CONFIG.store.duration,
      }}
    >
      {children}
    </MotionProjectStoreWrapper>
  );
};

const MotionProjectStoreWrapper = styled(motion.a)``;
